<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-select :items="empresas" v-model="empresaSelecionada" item-text="razao_social"
                            item-value="id_empresa" :label="$tc('company.self', 1)" clearable />
                    </v-col>
                    <!-- adicionar unidade -->
                    <v-col cols="12" sm="6" md="3">
                        <MultiplaEscolha 
                            :items="unidadesItens"
                            v-bind:selected-items.sync="unidadesSelecionadas"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$t('nav.registration.units')"
                            :max-items="2"
                        />
                    </v-col>
                    <!-- termina unidade -->
                    <v-col cols="12" sm="6" md="3">
                        <MultiplaEscolha :items="linhasItens" v-bind:selected-items.sync="linhasSelecionadas"
                            text="cod_linha" value="id_linha" :label="$tc('line.self', 1)" />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <MultiplaEscolha :items="veiculosItens" v-bind:selected-items.sync="veiculosSelecionados"
                            text="numero_ordem" value="id_veiculo" :label="$tc('vehicle.self', 1)" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="6">
                        <MultiplaEscolha :items="cercasItens" v-bind:selected-items.sync="cercasSelecionadas"
                            text="nome_cerca" value="id_cerca" :label="$tc('geofence.self', 2)" :max-items="2" />
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <MultiplaEscolha :items="usuarios" v-bind:selected-items.sync="usuariosSelecionados"
                            text="nome_usuario" value="id_usuario" :label="$t('user.username')" :max-items="2" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4" md="5">
                        <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti"
                            :time-picker-props="timeProps" :date-picker-props="dtiProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="5">
                        <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf"
                            :time-picker-props="timeProps" :date-picker-props="dtfProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

      <merus-data-table
        :headers="headers"
        :items="lancamentosFiltered"
        sort-by="dt_chegada"
        dense
        class="elevation-7"
        locale="pt"
        :loading="loading"
        :loading-text="$t('system.messages.loading')"
        style="border-radius: 10px; margin-top: 20px;"
      

 cod-tabela="RELLANCAMENTOSCONTROLADORES" @update:headers="headers = $event">
        <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('relControllersLaunch.title')"
                :token="token"
                :items="lancamentosFiltered"
                csv-title="lancamentoscontroladores"
                :pdf-title="$t('relControllersLaunch.title')"
                :pdf-headers="headers"
                pdf-filename="rellancamentoscont"
                hide-search
            />
        </template>
      </merus-data-table>
    </v-container>

</template>
<script>

import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import apiController from '@/utils/apiController';
import DateUtils from '../utils/dateutils';

export default {
    components: {
        MultiplaEscolha,
        MerusDataTable,
        CadastroToolbar
    },
    data: () => ({
    headers: [],
        user: null,
        token: null,
        config: null,
        formValidado: false,
        empresas: [],
        empresaSelecionada: null,
        linhas: [],
        linhasSelecionadas: [],
        veiculos: [],
        veiculosSelecionados: [],
        cercas: [],
        cercasSelecionadas: [],
        usuarios: [],
        usuariosSelecionados: [],
        unidades: [],
        unidadesSelecionadas: [],
        dti: null,
        dtf: null,
        timeProps: {
            useSeconds: true,
        },
        lancamentos: [],
        loading: false,
    }),
    computed: {
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
            }
        },
        headersWithProperties() {
            return this.headers.map(header => ({
                ...header,
                filtrable: true,
                sortable: true
            }));
        },
        veiculosItens() {
            return this.empresaSelecionada ? this.veiculos.filter((v) => v.id_empresa === this.empresaSelecionada) : this.veiculos;
        },
        linhasItens() {
            return this.empresaSelecionada ? this.linhas.filter((l) => l.id_empresa === this.empresaSelecionada) : this.linhas;
        },
        cercasItens() {
            return this.cercas;
        },
        unidadesItens() {
            return this.unidades;
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
            }
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return {
                min: min,
            }
        },
        lancamentosFiltered() {
            let dados = this.lancamentos;
            if (this.veiculosSelecionados.length > 0) {
                dados = dados.filter((d) => this.veiculosSelecionados.includes(d.id_veiculo));
            }

            if (this.linhasSelecionadas.length > 0) {
                dados = dados.filter((d) => this.linhasSelecionadas.includes(d.id_linha));
            }

            if (this.cercasSelecionadas.length > 0) {
                dados = dados.filter((d) => this.cercasSelecionadas.includes(d.id_cerca));
            }

            if (this.usuariosSelecionados.length > 0) {
                dados = dados.filter((d) => this.usuariosSelecionados.includes(d.id_usuario));
            }

            if (this.unidadesSelecionadas.length > 0) {
                const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
                dados = dados.filter((d) => {
                    const unidadesRow =
                        Array.isArray(d.unidades) && d.unidades.length > 0
                            ? d.unidades.map((id) => Number(id))
                            : d.id_unidade != null && d.id_unidade !== ''
                                ? [Number(d.id_unidade)]
                                : [];
                    return selecionadas.some((n) => {
                        if (n === -1) {
                            return unidadesRow.length === 0 || unidadesRow.includes(-1);
                        }
                        return unidadesRow.includes(n);
                    });
                });
            }

            return dados;
        }
    },
    watch: {
      '$i18n.locale'() {
        this.initialize();
      }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    methods: {

        initialize() {
            this.getConfig();
            this.populaEmpresas();
            this.populaLinhas();
            this.populaVeiculos();
            this.populaCercas();
            this.populaUsuarios();
            this.populaUnidades();
        },
        getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
              onSuccess: (response) => {
                  this.config = response.data[0];
                  [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
              },
              onError: (e) => {
                  this.erro = {
                      type: "Axios",
                      message: e.message,
                      status: e.response.status
                  };
              },
          });
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                onSuccess: (response) => {
                    this.empresas = response.data;
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        },
        populaLinhas() {
            apiController.request(apiController.endpoints.getLinhasativas, {
                onSuccess: (response) => {
                    this.linhas = response.data;
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        },
        populaVeiculos() {
            apiController.request(apiController.endpoints.getallVeiculosativos, {
                onSuccess: (response) => {
                    this.veiculos = response.data;
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        },
        populaCercas() {
            apiController.request(apiController.endpoints.getallCercasativas, {
                onSuccess: (response) => {
                    this.cercas = response.data;
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        },
        populaUsuarios() {
            apiController.request(apiController.endpoints.getallUsuarios, {
                data: {},
                onSuccess: (response) => {
                    this.usuarios = response.data;
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        },
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidadesativas, {
                onSuccess: (response) => {
                    this.unidades = [{ id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' }, ...(response.data || [])];
                },
                onError: (e) => {
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response ? e.response.status : null
                    };
                },
            });
        },
        populaRelatorio() {
            this.loading = true;
            let dti = DateUtils.getDateSQLFormatted(this.dti);
            let dtf = DateUtils.getDateSQLFormatted(this.dtf);

            apiController.request(apiController.endpoints.getallViagenscontroladoresdata, {
                params: { dti, dtf },
                onSuccess: (response) => {
                    this.lancamentos = response.data;
                    this.loading = false;
                },
                onError: (e) => {
                    this.loading = false;
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                },
            });
        }
    }
}
</script>
<style lang="">

</style>